
import tabletConstants from '../constants/tablet';


const tablets = (state = [], action) => {
  switch (action.type) {
    case tabletConstants.FETCH:
      return action.tablets;
    case tabletConstants.UPDATE: {
      const tabletIndex = state.findIndex(tablet => tablet.macAddress === action.tablet.macAddress);
      const initialState = [...state];
      initialState[tabletIndex] = { ...initialState[tabletIndex], ...action.tablet };
      return initialState;
    }
    default:
      return state;
  }
};

export default tablets;
